if (window.location.href === "https://www.hrisikesh.com/collections/3ml-collection") {
  window.location.href = "https://www.hrisikesh.com/products/gift-of-choice";
};

if (window.location.href === "https://www.hrisikesh.com/collections/3ml-collection") {
  // Check if the screen width is less than or equal to 768 pixels (standard size for small screens)
  if (window.innerWidth <= 768) {
    window.location.href = "https://www.hrisikesh.com/products/gift-of-choice";
  };
};


document.addEventListener('DOMContentLoaded', function() {
        // Get the element to listen for clicks
        var bannerInner = document.querySelector('.dt-sc-grid-banner-inner.text-center');

        // Add a click event listener to the element
        bannerInner.addEventListener('click', function() {
            // Redirect to the specified URL
            window.location.href = 'https://www.hrisikesh.com/collections/scented-candles-collection';
        });
    });

document.addEventListener("DOMContentLoaded", function() {
    // Find the element with the specified class
    var bannerElement = document.querySelector(".dt-sc-grid-banner.overlay-style.content-df477972-d16d-4a34-957e-aaba3b8d80a8");

    // Add a click event listener to the element
    bannerElement.addEventListener("click", function() {
        // Redirect to the specified URL
        window.location.href = "https://www.hrisikesh.com/collections/original-attar-collection-for-men-women";
    });
});

document.addEventListener("DOMContentLoaded", function() {
  // Find the element with the specified class name
  var banner = document.querySelector(".dt-sc-grid-banner.overlay-style.content-0d02c8d2-2eb3-4bd9-bb82-72ad5f5500c4");

  // Add click event listener to the banner element
  banner.addEventListener("click", function() {
    // Redirect to the specified URL
    window.location.href = "https://www.hrisikesh.com/collections";
  });
});


